<template>
  <qx-card-form title="线路信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <span slot="cmMileageNumberTip">
        <span class="error" style="margin-left: 16px" v-show="calcIng"
          >距离计算中...</span
        >
      </span>
      <span slot="mileageNumberTip">
        <span class="error" style="margin-left: 16px" v-show="calcIng"
          >距离计算中...</span
        >
      </span>
      <TransAddress
        slot="address"
        :middleData="otherFormData.middleData"
        @add="addMiddle"
        @del="delMiddle"
      >
        <!-- 起点 -->
        <section slot="start">
          <el-form-item label="导航地址">
            <ChooseAddressMap
              ref="sourceAddress"
              v-model="otherFormData.sourceAddress"
              @cc="onChangeSource"
            />
          </el-form-item>
          <el-form-item label="出发地址">
            <el-input
              class="norderFormWidth"
              v-model="otherFormData.navigatSourceLocation"
              placeholder="请输入"
            >
              <span
                slot="suffix"
                class="inputSlotText cur primary"
                @click="showFrequentlyUsedAddressDialog('sourceAddress')"
                >选择</span
              ></el-input
            >
          </el-form-item>
        </section>
        <!-- 起点 end -->
        <!-- 中间 -->
        <section
          v-for="(item, index) in otherFormData.middleData"
          :key="item.id"
          :slot="'middle' + index"
        >
          <el-form-item label="导航地址">
            <ChooseAddressMap
              v-model="otherFormData.middleData[index].desAddress"
              @cc="(data) => onChangeMiddle(data, index)"
            />
          </el-form-item>
          <el-form-item label="途经地址">
            <el-input
              class="norderFormWidth"
              v-model="otherFormData.middleData[index].navigatDesLocation"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="到达时限">
            <el-input
              class="norderFormWidth"
              v-model="otherFormData.middleData[index].arriveTime"
              placeholder="请输入"
              @blur="arriveTime(index)"
            >
              <span slot="suffix" class="inputSlotText">小时</span>
            </el-input>
          </el-form-item>
        </section>
        <!-- 中间 end -->
        <!-- 终点 -->
        <section slot="end">
          <el-form-item label="导航地址">
            <ChooseAddressMap
              ref="navigatDesLocation"
              v-model="otherFormData.desAddress"
              @cc="onChangeDes"
            />
          </el-form-item>
          <el-form-item label="目的地址">
            <el-input
              class="norderFormWidth"
              v-model="otherFormData.navigatDesLocation"
              placeholder="请输入"
            >
              <span
                slot="suffix"
                class="inputSlotText cur primary"
                @click="showFrequentlyUsedAddressDialog('navigatDesLocation')"
                >选择</span
              >
            </el-input>
          </el-form-item>
          <el-form-item label="到达时限" :required="true">
            <el-input
              class="norderFormWidth"
              v-model="otherFormData.arriveTime"
              placeholder="请输入"
              @blur="arriveTime"
            >
              <span slot="suffix" class="inputSlotText">小时</span>
            </el-input>
          </el-form-item>
        </section>
        <!-- 终点 end -->
      </TransAddress>
    </qx-custom-form>
    <ChooseFrequentlyUsedAddress
      :isRadio="true"
      ref="chooseFrequentlyUsedAddress"
      @change="handleFrequentlyUsedAddressChange"
    />
  </qx-card-form>
</template>

<script>
import TransAddress from 'components/transAddress';
import ChooseAddressMap from 'components/chooseAddressMap/chooseAddressMap';
import ChooseFrequentlyUsedAddress from 'components/chooseFrequentlyUsedAddress/chooseFrequentlyUsedAddress';
import {
  calcDistance, isNegativeNumber,
} from '@qx/utils';
export default {
  components: {
    TransAddress,
    ChooseAddressMap,
    ChooseFrequentlyUsedAddress,
  },
  data () {
    return {
      mapTar: '',
      frequentlyUsedAddressCurrentSelect: null,
      sourceTemp: {},
      desTemp: {},
      calcIng: false,
      otherFormData: {
        sourceAddress: {}, // 导航地址
        navigatSourceLocation: '', // 出发地址
        desAddress: {}, // 目的地址
        navigatDesLocation: '', // 目的地址
        arriveTime: '', // 到达时限
        middleData: [], // 经停点
      },
      baseForm: {
        inline: true,
        form: [
          {
            label: 'address',
            value: 'address',
            slot: true,
            allCustom: true,
          },
          {
            label: '客户公里数',
            value: 'cmMileageNumber',
            type: 'input',
            width: '240px',
            unit: 'KM',
            onChange: () => {
              this.$emit('calCostPrice');
            },
          },
          {
            label: '承运商公里数',
            value: 'mileageNumber',
            type: 'input',
            width: '240px',
            unit: 'KM',
          },
          {
            label: '线路名称',
            value: 'lineCodeName',
            type: 'input',
            width: '240px',
          },
          {
            label: '发车时间',
            value: 'taiwanDate',
            type: 'time',
            width: '240px',
            attr: {
              format: 'HH:mm',
            },
          },
        ],
        rules: {
          cmMileageNumber: [ // 客户公里数
            { required: true, message: '请输入客户公里数', trigger: 'blur' },
          ],
          mileageNumber: [ // 承运商公里数
            { required: true, message: '请输入承运商公里数', trigger: 'blur' },
          ],
          lineCodeName: [ // 线路名称
            { required: true, message: '请输入线路名称', trigger: 'blur' },
          ],
          // taiwanDate: [ // 发车时间
          //   { required: true, message: '请选择发车时间', trigger: 'blur' },
          // ],
        },
      },
    };
  },
  methods: {
    showMap (tar) {
      this.mapTar = tar;
      this.$refs.mapDialog.show();
    },
    // 弹出常用地址弹窗
    showFrequentlyUsedAddressDialog (type) {
      this.frequentlyUsedAddressCurrentSelect = type;
      this.$refs.chooseFrequentlyUsedAddress.show();
    },
    // 选择常用地址
    handleFrequentlyUsedAddressChange (data) {
      if (this.frequentlyUsedAddressCurrentSelect) {
        this.$refs[this.frequentlyUsedAddressCurrentSelect].handleMapChoose({
          point: {
            lat: Number(data.lat),
            lng: Number(data.lng),
          },
          address: data.addressDetail,
          addressShow: data.addressShow,
          addressDetail: {
            province: data.provinceName || '',
            city: data.cityName || '',
            district: data.districtName || '',
            street: '',
            streetNumber: '',
          },
          provinceId: data.provinceId,
          cityId: data.cityId,
          countryId: data.countryId,
        });
      }
    },
    addMiddle (index) {
      if (index === undefined) {
        this.otherFormData.middleData.push({
          desAddress: {}, // 导航地址
          navigatDesLocation: '',
          arriveTime: '',
        });
      } else {
        this.otherFormData.middleData.splice(index + 1, 0, {
          desAddress: {}, // 导航地址
          navigatDesLocation: '',
          arriveTime: '',
        });
      }
    },
    delMiddle (index) {
      this.otherFormData.middleData.splice(index, 1);
      this.fnCalcDistance();
    },
    arriveTime (index) {
      this.otherFormData.arriveTime = isNegativeNumber(this.otherFormData.arriveTime);
      this.otherFormData.middleData[index].arriveTime = isNegativeNumber(this.otherFormData.middleData[index].arriveTime);
    },
    onChangeSource (data) {
      this.otherFormData.navigatSourceLocation = data.addressShow || data.address;
      this.sourceTemp = data.addressDetail;
      this.setLineCodeNameAndCalcDistance();
    },
    onChangeDes (data) {
      this.otherFormData.navigatDesLocation = data.addressShow || data.address;
      this.desTemp = data.addressDetail;
      this.setLineCodeNameAndCalcDistance();
    },
    // 设置线路名称和计算距离
    setLineCodeNameAndCalcDistance () {
      // 防止修改的时候丢失信息
      const preLineCodeName = this.$refs.baseForm.getVal('lineCodeName');
      let preSourceAddress = '';
      let preDesAddress = '';
      if (preLineCodeName) {
        const aPreLineCodeName = preLineCodeName.split('-');
        if (aPreLineCodeName && aPreLineCodeName.length > 1) {
          preSourceAddress = aPreLineCodeName[0];
          preDesAddress = aPreLineCodeName[1];
        }
      }
      // 过滤掉始发和终点的一些字眼
      const sourceAddress = `${this.sourceTemp.city ? this.sourceTemp.city.replace(/自治州$|地区$|市$/g, '') : ''}${this.sourceTemp.district ? this.sourceTemp.district.replace(/市$|县$|区$/g, '') : ''}`;
      const desAddress = `${this.desTemp.city ? this.desTemp.city.replace(/自治州$|地区$|市$/g, '') : ''}${this.desTemp.district ? this.desTemp.district.replace(/市$|县$|区$/g, '') : ''}`;
      let lineCodeName = `${sourceAddress || preSourceAddress} - ${desAddress || preDesAddress}`;
      this.$refs.baseForm.setVal('lineCodeName', lineCodeName);
      this.fnCalcDistance();
    },
    onChangeMiddle (data, index) {
      this.otherFormData.middleData[index].navigatDesLocation = data.address;
      this.fnCalcDistance();
    },
    async fnCalcDistance () {
      const sourceEand = this.otherFormData.sourceAddress.lng;
      const sourceNand = this.otherFormData.sourceAddress.lat;
      const desEand = this.otherFormData.desAddress.lng;
      const desNand = this.otherFormData.desAddress.lat;
      const middleData = this.otherFormData.middleData;

      let sourceCityName = '';
      let desCityName = '';
      // 拿线路名来切出出发地 和 目的地
      const lineCodeName = this.$refs.baseForm.getVal('lineCodeName');
      if (lineCodeName && lineCodeName.length) {
        const cityList = lineCodeName.replace(/\s/g, '').split('-');
        if (cityList.length > 1) {
          sourceCityName = cityList[0];
          desCityName = cityList[1];
        }
      }

      this.calcIng = true;
      const distance = await calcDistance({
        sourceEand,
        sourceNand,
        desEand,
        desNand,
        sourceCityName,
        desCityName,
        middleData,
      });
      this.calcIng = false;
      this.setDistant(distance);
    },

    setDistant (distance) {
      // 客户公里数
      this.$refs.baseForm.setVal('cmMileageNumber', distance);
      // 承运商公里数
      this.$refs.baseForm.setVal('mileageNumber', distance);
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        const subWayList = this.otherFormData.middleData.map((item) => ({ // 经停点
          desAddress: item.desAddress.address, // 目的地址
          desEand: item.desAddress.lng, // 目的地经度
          desNand: item.desAddress.lat, // 目的地纬度
          desProvince: item.desAddress.provinceId, // 目的地省ID
          desCity: item.desAddress.cityId, // 目的地市id
          desCounty: item.desAddress.countryId, // 目的地区id
          navigatDesLocation: item.navigatDesLocation, // 途经地址
          arriveTime: item.arriveTime, // 到达时间
        }));
        formData = {
          sourceAddress: this.otherFormData.sourceAddress.address, // 导航地址
          sourceEand: this.otherFormData.sourceAddress.lng, // 始发经度
          sourceNand: this.otherFormData.sourceAddress.lat, // 始发纬度
          sourceProvince: this.otherFormData.sourceAddress.provinceId, // 始发省id
          sourceCity: this.otherFormData.sourceAddress.cityId, // 始发市id
          sourceCounty: this.otherFormData.sourceAddress.countryId, // 始发县区id
          navigatSourceLocation: this.otherFormData.navigatSourceLocation, // 出发地址
          subWayList: cache ? subWayList : JSON.stringify(subWayList),
          desAddress: this.otherFormData.desAddress.address, // 目的地址
          desEand: this.otherFormData.desAddress.lng, // 目的地经度
          desNand: this.otherFormData.desAddress.lat, // 目的地纬度
          desProvince: this.otherFormData.desAddress.provinceId, // 目的地省ID
          desCity: this.otherFormData.desAddress.cityId, // 目的地市id
          desCounty: this.otherFormData.desAddress.countryId, // 目的地县区id
          navigatDesLocation: this.otherFormData.navigatDesLocation, // 目的地址
          arriveTime: this.otherFormData.arriveTime, // 到达时限

          cmMileageNumber: formData.cmMileageNumber, // 客户公里数
          mileageNumber: formData.mileageNumber, // 承运商公里数
          lineCodeName: formData.lineCodeName, // 线路名称
          taiwanDate: this.formatDate(formData.taiwanDate, 2), // 发车时间
        };
        formData.desTemp = this.desTemp;
        formData.sourceTemp = this.sourceTemp;
      }
      return formData;
    },
    cacheData () {
      const res = this.handleSubData(true);
      return res;
    },

    async sub () {
      const res = await this.handleSubData();
      if (res) {
        if (res.subWayList) {
          const subWayList = JSON.parse(res.subWayList);
          const unFinishSubWay = subWayList.filter((item) => !item.desEand || !item.desNand || !item.arriveTime);
          if (unFinishSubWay && unFinishSubWay.length) {
            this.$message({
              type: 'warning',
              message: '请补充完整经停点的【导航地址】、【目的地址】和【到达时限】',
            });
            return null;
          }
        }
        delete res.desTemp;
        delete res.sourceTemp;
      }
      return res;
    },
    init (data = {}) {
      if (!data.subWayList) {
        data.subWayList = [];
      }
      if (!data.lineCodeName) {
        this.sourceTemp = {};
        this.desTemp = {};
      }
      this.otherFormData = {
        sourceAddress: {
          address: data.sourceAddress, // 导航地址
          lng: data.sourceEand, // 始发经度
          lat: data.sourceNand, // 始发纬度
          provinceId: data.sourceProvince, // 始发省id
          cityId: data.sourceCity, // 始发市id
          countryId: data.sourceCounty, // 始发县区id
        },
        navigatSourceLocation: data.navigatSourceLocation, // 出发地址
        middleData: data.subWayList.map((item) => ({
          desAddress: {
            address: item.desAddress, // 目的地址
            lng: item.desEand, // 目的地经度
            lat: item.desNand, // 目的地纬度
            provinceId: item.desProvince, // 目的地省ID
            cityId: item.desCity, // 目的地市id
            countryId: item.desCounty, // 目的地区id
          },
          navigatDesLocation: item.navigatDesLocation, // 途经地址
          arriveTime: item.arriveTime, // 到达时间
        })),
        desAddress: {
          address: data.desAddress, // 目的地址
          lng: data.desEand, // 目的地经度
          lat: data.desNand, // 目的地纬度
          provinceId: data.desProvince, // 目的地省ID
          cityId: data.desCity, // 目的地市id
          countryId: data.desCounty, // 目的地县区id
        },
        navigatDesLocation: data.navigatDesLocation, // 目的地址
        arriveTime: data.arriveTime, // 到达时限
      };
      // 客户公里数
      this.$refs.baseForm.setVal('cmMileageNumber', data.cmMileageNumber || '');
      // 承运商公里数
      this.$refs.baseForm.setVal('mileageNumber', data.mileageNumber || '');
      // 线路名称
      this.$refs.baseForm.setVal('lineCodeName', data.lineCodeName || '');
      // 发车时间
      this.$refs.baseForm.setVal('taiwanDate', data.taiwanDate ? new Date('2020-10-10 ' + data.taiwanDate + ':00') : null);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
